// app/src/lib/scale/tax.js — client wrapper for the WA DOR rate lookup.
//
// Calls the server tax-rate-lookup Lambda (which talks to WA DOR + caches). Only
// WA is taxed today; other states resolve to taxable:false. We never compute the
// rate client-side — the server returns the authoritative DOR rate + location
// code for the service address.

import { getConfig } from '../config.js';
import { getAccessToken } from '../auth/cognitoClient.js';

/**
 * @param {{ street?:string, city?:string, state?:string, zip?:string }} addr
 * @returns {Promise<{ taxable:boolean, resolved?:boolean, combinedRate:number, locationCode?:string, stateRate?:number, localRate?:number, rta?:boolean, code?:string }>}
 */
export async function lookupRate(addr = {}) {
  const cfg = getConfig();
  const at = await getAccessToken().catch(() => null);
  const qs = new URLSearchParams({
    state: addr.state || '', street: addr.street || '', city: addr.city || '', zip: addr.zip || '',
  });
  try {
    const res = await fetch(`${cfg.apiBaseUrl}/tax/rate?${qs}`, {
      headers: at ? { authorization: `Bearer ${at}` } : {},
    });
    if (!res.ok) return { taxable: false, combinedRate: 0, error: res.status };
    return await res.json();
  } catch (e) {
    return { taxable: false, combinedRate: 0, error: String(e?.message || e) };
  }
}

/** Tax in cents for an amount at a rate (e.g. 0.083). */
export function taxCents(amountCents, rate) {
  return Math.round((amountCents || 0) * (rate || 0));
}
